// Own the animation on the actual panel so Shopify section replacements cannot
// leave it attached to a discarded node. Used by both the full cart and drawer.
class JmtShippingProgress extends HTMLElement {
  connectedCallback() {
    this.fill = this.querySelector('.jb-shipping-fill');
    this.drawer = this.closest('cart-drawer');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.animations = [];
    this.played = false;
    this.visible = false;
    if (!this.fill?.animate || !window.IntersectionObserver) return;

    this.reset();
    this.intersection = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .98;
      this.playWhenVisible();
    }, { threshold: [0, .98, 1] });
    this.intersection.observe(this);
    if (this.drawer) {
      this.drawerObserver = new MutationObserver(() => {
        if (!this.drawer.classList.contains('active')) this.reset();
        else this.playWhenVisible();
      });
      this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
    }
    this.onMotionChange = () => { this.reset(); this.playWhenVisible(); };
    this.motion.addEventListener('change', this.onMotionChange);
  }

  reset() {
    this.animations?.forEach(animation => animation.cancel());
    this.animations = [];
    this.played = false;
    // Reduced-motion and no-JS shoppers get the correct static final state.
    this.fill.style.transform = this.motion.matches ? '' : 'scaleX(0)';
  }

  playWhenVisible() {
    if (!this.isConnected || !this.visible || this.played || this.motion.matches ||
        (this.drawer && !this.drawer.classList.contains('active'))) return;
    this.played = true;
    // Wait half a second once the panel is in view, then gently ease to its
    // actual value. Never animate the amount or the accessible progress value.
    const timing = { duration: 1400, delay: 500, easing: 'cubic-bezier(0,0,.58,1)', fill: 'both' };
    const sweep = this.fill.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], timing);
    const highlight = this.animate([
      { boxShadow: '0 0 0 0 rgba(139,103,77,0)' },
      { boxShadow: '0 0 0 3px rgba(139,103,77,.18)', offset: .4 },
      { boxShadow: '0 0 0 0 rgba(139,103,77,0)' }
    ], timing);
    this.animations = [sweep, highlight];
    Promise.allSettled(this.animations.map(animation => animation.finished)).then(() => {
      if (this.animations[0] !== sweep) return;
      this.fill.style.transform = '';
      this.animations.forEach(animation => animation.cancel());
      this.animations = [];
    });
  }

  disconnectedCallback() {
    this.intersection?.disconnect();
    this.drawerObserver?.disconnect();
    this.motion?.removeEventListener('change', this.onMotionChange);
    this.animations?.forEach(animation => animation.cancel());
    this.animations = [];
  }
}

if (!customElements.get('jmt-shipping-progress')) {
  customElements.define('jmt-shipping-progress', JmtShippingProgress);
}
